import Skeleton from 'react-loading-skeleton';

export default function ListLoader({
  count,
  height,
}: {
  count: number;
  height: number;
}) {
  return (
    <div className=" flex flex-col gap-3x w-full container-fluid py-8x">
      {Array(count)
        .fill(0)
        .map(() => {
          return (
            <>
              <Skeleton height={height} width="100%" borderRadius={8} />
            </>
          );
        })}
    </div>
  );
}
